export const getApiErrorMessage = (error, fallback = 'Ошибка') => {
  const responseError = error?.response?.data?.error

  if (Array.isArray(responseError) && responseError[0]) {
    return responseError[0]
  }

  if (typeof responseError === 'string' && responseError) {
    return responseError
  }

  if (typeof error?.response?.data === 'string' && error.response.data) {
    return error.response.data
  }

  return error?.message || fallback
}
